import type { ReactNode } from "react";

/** Every empty list says what will appear here and offers one next step. */
export function EmptyState({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border-strong bg-surface px-6 py-12 text-center">
      {icon ? (
        <span aria-hidden="true" className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-subtle text-accent">
          {icon}
        </span>
      ) : null}
      <p className="font-heading text-lg font-semibold text-heading">{title}</p>
      {description ? <div className="max-w-prose text-fg-muted">{description}</div> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
